export const border = {
  borderRadius: {
    custom: '2rem',
  },
  borderWidth: {
    large: '1rem',
  },
};
